import React from "react";
import { useFormikContext } from "formik";
import sumBy from "lodash/sumBy";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

import useAuth from "../../../hooks/useAuth";
import Input from "../../form/Input";
import RackLocations from "./RackLocations";
import ShipmentItemQuantityField from "./ShipmentItemQuantityField";

export function getRestockTotal(locations) {
  return sumBy(locations, "restock_sub_qty") || 0;
}

export default function Fields({
  asset,
  projectId,
  multiSelect,
  openPalletBreakdown,
  displayNewAvailableQuantity,
  displayTotalQuantityChange,
  displayShipmentId,
  displayAddAnotherLocation,
  displayDeleteLocation,
  displayDuplicate,
  hideLocation,
  disableQuantity,
  shipmentItemQuantity,
  onShipmentItemQuantityUpdate,
}) {
  const { user } = useAuth();
  const { values } = useFormikContext();
  const { settings } = user.company;
  const restockTotal = getRestockTotal(values.locations) - values.deletedQuantity;
  const newOpenStockQty = asset.availableQuantity + (restockTotal || 0);
  const hasSubQty = values.locations.some(location => location.sub_qty !== 0);

  return (
    <>
      {settings.restock_additional_fields && (
        <>
          <Grid size={6}>
            <Input name="trackingNumber" label="Tracking Number" />
          </Grid>
          <Grid size={6}>
            <Input name="carrierName" label="Carrier Name" />
          </Grid>
          <Grid size={6}>
            <Input name="senderName" label="Sender Name" />
          </Grid>
          <Grid size={6}>
            <Input name="orderNumber" label="Order Number" />
          </Grid>
          <Grid size={6}>
            <Input name="poNumber" label="PO#" />
          </Grid>
        </>
      )}
      {!settings.receiving_wizard && ( // If receiving wizard is enabled, don't show notes field
        <>
          <Grid size={settings.restock_additional_fields ? 6 : 12}>
            <Input name="notes" label="Receiving Notes" />
          </Grid>
        </>
      )}

      <Grid size={12}>
        <RackLocations
          multiSelect={multiSelect}
          locations={values.locations}
          openPalletBreakdown={openPalletBreakdown}
          displayShipmentId={displayShipmentId}
          displayAddAnotherLocation={displayAddAnotherLocation}
          displayDeleteLocation={displayDeleteLocation}
          displayDuplicate={displayDuplicate}
          hideLocation={hideLocation}
          projectId={projectId}
          disableQuantity={disableQuantity}
        />
      </Grid>

      <Grid size={12}>
        <ShipmentItemQuantityField
          shipmentItemQuantity={shipmentItemQuantity}
          availableQuantity={asset.availableQuantity}
          onShipmentItemQuantityUpdate={onShipmentItemQuantityUpdate}
        />
      </Grid>

      {displayTotalQuantityChange && restockTotal !== 0 && (
        <Grid size={12}>
          <Box display="flex" justifyContent="flex-end">
            <TextField
              disabled
              size="small"
              label={
                settings.simple_inventory_modal ? "Total Quantity Change" : "QTY Received Total"
              }
              value={restockTotal || ""}
            />
          </Box>
        </Grid>
      )}

      {displayNewAvailableQuantity && hasSubQty && (
        <Grid size={12}>
          <Box display="flex" justifyContent="flex-end">
            <TextField
              disabled
              size="small"
              label={`New ${user.company.settings.quantity_label}`}
              value={newOpenStockQty}
            />
          </Box>
        </Grid>
      )}
    </>
  );
}
